import {styled} from '@mui/material/styles';
import {Sidebar} from 'react-admin';
import MenuFooter from '../menuFooter/menuFooter.component';

const SidebarContent = styled('div')({
  height: '100%',
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
});

const CustomSidebar = (props: any) => {
  return (
    <Sidebar {...props} size={200}>
      <SidebarContent>
        {props.children}
        <MenuFooter />
      </SidebarContent>
    </Sidebar>
  );
};

export default CustomSidebar;
